import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AjaxService } from 'src/app/service/ajax.service';
import { UtilService } from 'src/app/service/util.service';

@Component({
  selector: 'app-lista-programa-empresa',
  templateUrl: './lista-programa-empresa.component.html',
  styleUrls: ['./lista-programa-empresa.component.scss']
})
export class ListaProgramaEmpresaComponent implements OnInit {

  public arrayTriagem: [];
  query: string;

  constructor(
    private router: Router,
    public util: UtilService,
    private ajax: AjaxService
  ) { }

  ngOnInit() {
    this.buscar();
  }

  adicionarNovoPrograma(){
    this.router.navigate(['/cadastro-programa']);
  }

  alertas(){
    this.router.navigate(['/avisos']);
  }


  documentos(){
    this.router.navigate(['/ver-documentos-empresa']);
  }



  buscar(){
    this.util.showLoading();
    //let url = API + "Triagem/Triagem";  
    let url = "fake-data/programa.json";  
    return this.ajax.get(url)
    .subscribe(response  => {
      this.arrayTriagem = response.slice(0,2);

      this.util.closeLoading();      
    }, err => {
      debugger
      this.util.closeLoading();
      this.util.toasterShowError("Atenção", "Erro ao Buscar Triagem");
    });
  }
}
